<template>
	<div class="btn-group d-flex btn-switch price-switch btn-group-price mb-2">
		<button
			type="button"
			class="btn btn-monatsrate flex-fill"
			@click="updatePayment('finance')"
			:class="
				this.$store.state.price.filter === 'finance'
					? 'btn-finance current'
					: 'btn-light'
			"
		>
			<span>Finanz.</span>
		</button>
		<button
			type="button"
			class="btn btn-kaufpreis flex-fill"
			@click="updatePayment('fixed')"
			:class="
				this.$store.state.price.filter === 'fixed'
					? 'btn-dark current'
					: 'btn-light'
			"
		>
			<span>Kaufen</span>
		</button>
		<button
			type="button"
			class="btn btn-monatsrate flex-fill"
			@click="updatePayment('leasing')"
			:class="
				this.$store.state.price.filter === 'leasing'
					? 'btn-secondary current'
					: 'btn-light'
			"
		>
			<span>Leasen</span>
		</button>
	</div>
</template>

<script>
import store from '@/store'

export default {
	name: 'BtnPriceSwitch',
	methods: {
		updatePayment(price) {
			store.commit('updatePrice', price)
			this.$emit('updateFilter')
		},
	},
}
</script>
